export const DEFAULT_POSTFIX: string = '';export const THEORY_POSTFIX: string = '_theory';export const rsPostfixList = [DEFAULT_POSTFIX, THEORY_POSTFIX];